import * as React from "react";
import type { SVGProps } from "react";
const SvgDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    fillRule="evenodd"
    clipRule="evenodd"
    imageRendering="optimizeQuality"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    viewBox="0 0 4233.32 4233.32"
    {...props}
  >
    <path
      fillRule="nonzero"
      d="M33.36 1796.3c-44.25-44.25-44.25-116.18 0-160.42 44.24-44.25 116.17-44.25 160.41 0L2003.09 3445.2V113.57c0-62.71 50.87-113.58 113.57-113.58 62.7 0 113.57 50.87 113.57 113.58V3445.2l1809.32-1809.32c44.24-44.25 116.17-44.25 160.41 0 44.25 44.24 44.25 116.17 0 160.42L2200.65 3795.61l-3.78 3.78-2.13 2.13-1.66 1.66-.47.23-2.13 1.9-1.66 1.42-.47.47-2.36 1.66-1.42 1.42-.71.47-2.37 1.66-1.42.94-.95.48-2.36 1.65-1.19.71-1.18.71-2.6 1.42-.95.71-3.78 1.89-1.19.71-1.42.48-2.6 1.18-.94.47-1.66.48-2.37.94-2.6.95-2.6.94-1.19.48-1.42.47-2.83.71-1.19.47-1.42.24-2.6.47-1.42.48h-1.18l-2.84.71-1.66.23h-.94l-2.84.48-5.45.47-2.12.24h-5.92v.23-.23h-5.92l-2.12-.24-5.45-.47-2.84-.48h-.94l-1.66-.23-2.84-.71h-1.18l-1.42-.48-2.6-.47-1.42-.24-1.19-.47-2.83-.71-1.42-.47-1.19-.48-2.6-.94-2.6-.95-2.37-.94-1.66-.48-.94-.47-2.6-1.18-1.42-.48-1.19-.71-3.78-1.89-.95-.71-2.6-1.42-1.18-.71-1.19-.71-2.36-1.65-.95-.48-1.42-.94-2.37-1.66-.71-.47-1.42-1.42-2.36-1.66-.47-.47-1.66-1.42-2.13-1.9-.47-.23-1.66-1.66-2.13-2.13-3.78-3.78L33.36 1796.3zM834.5 4233.33c-62.7 0-113.57-50.87-113.57-113.58 0-62.7 50.87-113.57 113.57-113.57h2564.32c62.7 0 113.57 50.87 113.57 113.57 0 62.71-50.87 113.58-113.57 113.58H834.5z"
      className="fil0"
    />
  </svg>
);
export default SvgDownload;
